import { FormType } from '@cod-monorepo/interfaces';
import { StepConfig } from '../../../../shared/types/step-config.type';

export const ProductDatingDomesticStepConfig: StepConfig = {
    type: FormType.PRODUCT_DATING_DOMESTIC
};
